import { Edge, Node } from 'reactflow';
import { PROMPT_ASSISTANT_INPUT_ID } from '../PromptAssistant/types';

export const NODE_ASSISTANT_FLOW_ID = import.meta.env.VITE_NODE_CHAT_FLOW_ID || '';
export { PROMPT_ASSISTANT_INPUT_ID as NODE_ASSISTANT_INPUT_ID };

export interface NodeAssistantProps {
  nodeId: string;
  nodeType: string;
  nodeData: Record<string, unknown>;
  edges: Edge[];
  flowSummary: string;
}

export interface NodeAssistantMessage {
  role: 'user' | 'assistant';
  content: string;
  timestamp: string;
}

export interface PendingNodeOutput {
  previewText: string;
  node: Node;
  edges: Edge[] | null;
  rawResponse: string;
}
